<!-- 销售结算申请数据操作 -->
<template>
    <div>
        <purchaseGoodsTemplate @selectDataAction="selectDataAction" ref="purchaseGoodsTemplate"></purchaseGoodsTemplate>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form class="baseForm" label-width="120px" :model="sendDataInfo" id="mainInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                          :key="formOneKey" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <!-- 申请日期 -->
                                                <df-date v-if="formOneValue.fieldType == 'date'" :isShowLong="false" :isdisabled="formOneValue.isChange == 0" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                <el-tooltip v-else-if="formOneValue.entityField == 'coName'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                              @clear="clearClick(formOneValue.setField)"
                                                              :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (tableType == 0 && sendDataInfo.suSettleInvoiceVos.length > 0) || (tableType == 1 && sendDataInfo.suSettleInvoiceDetailVos.length > 0)">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (tableType == 0 && sendDataInfo.suSettleInvoiceVos.length > 0) || (tableType == 1 && sendDataInfo.suSettleInvoiceDetailVos.length > 0)">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="formOneValue.entityField == 'cmName'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                              @clear="clearClick(formOneValue.setField)"
                                                              :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (tableType == 0 && sendDataInfo.suSettleInvoiceVos.length > 0) || (tableType == 1 && sendDataInfo.suSettleInvoiceDetailVos.length > 0)">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (tableType == 0 && sendDataInfo.suSettleInvoiceVos.length > 0) || (tableType == 1 && sendDataInfo.suSettleInvoiceDetailVos.length > 0)">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="formOneValue.entityField == 'salesName'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                              @clear="clearClick(formOneValue.setField)"
                                                              :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (tableType == 0 && sendDataInfo.suSettleInvoiceVos.length > 0) || (tableType == 1 && sendDataInfo.suSettleInvoiceDetailVos.length > 0)">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (tableType == 0 && sendDataInfo.suSettleInvoiceVos.length > 0) || (tableType == 1 && sendDataInfo.suSettleInvoiceDetailVos.length > 0)">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="formOneValue.entityField == 'opmName'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                              @clear="clearClick(formOneValue.setField)"
                                                              :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (tableType == 0 && sendDataInfo.suSettleInvoiceVos.length > 0) || (tableType == 1 && sendDataInfo.suSettleInvoiceDetailVos.length > 0)">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (tableType == 0 && sendDataInfo.suSettleInvoiceVos.length > 0) || (tableType == 1 && sendDataInfo.suSettleInvoiceDetailVos.length > 0)">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                              @clear="clearClick(formOneValue.setField)" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <!-- 业务部门 -->
                                                <el-input v-else-if="formOneValue.entityField == 'depId'" disabled v-model="sendDataInfo.depName" :maxlength="$store.state.inputLength"
                                                          :readonly="formOneValue.isChange == 0"></el-input>
                                                <!-- 预收金额 -->
                                                <el-input v-else-if="formOneValue.entityField == 'preMoney'" :disabled="formOneValue.isChange == 0" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0"
                                                          @input="preMoneyChange">
                                                </el-input>
                                                <!-- <el-input v-else-if="formOneValue.entityField == 'cbiAddress'" @focus="openSearch(formOneValue.searchId, 0, 'cbiAddress')" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input> -->
                                                <!-- 备注 -->
                                                <el-input v-else-if="formOneValue.entityField == 'dsapmRemark'" type="textarea" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                          :maxlength="$store.state.inputLength"></el-input>
                                                <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isChange == 0" :maxlength="$store.state.inputLength"></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1"
                                                          v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                            sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.entityField == 'opmId'">{{ sendDataInfo.opmName }}</span>
                                                <span v-else-if="formOneValue.entityField == 'coId'">{{ sendDataInfo.coName }}</span>
                                                <span v-else-if="formOneValue.entityField == 'depId'">{{ sendDataInfo.depName }}</span>
                                                <span v-else-if="formOneValue.entityField == 'salesId'">{{ sendDataInfo.salesName }}</span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                    </span>
                                                </span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <!-- 明细信息 -->
                                    <div>
                                        <div class="flex" id="operateBtn">
                                            <el-radio-group v-model="tableType" @change="calculateTotal" :disabled="dataActionBox.actionType == 2">
                                                <el-radio-button :label="0">按单据结算</el-radio-button>
                                                <el-radio-button :label="1">按明细结算</el-radio-button>
                                            </el-radio-group>
                                            <div style="margin-left: 10px" v-if="dataActionBox.actionType != 2">
                                                <el-button type="primary" size="mini" @click="extract('sendDataInfo')">提取</el-button>
                                                <el-button v-if="tabForm[0].isExtract == 1" @click="openExtSearch()" size="mini" type="primary">提取外部订单</el-button>
                                                <el-button v-if="invoiceShow" @click="extract('sendDataInfo', 589745812934656)" size="mini" type="primary">提取开票申请</el-button>
                                                <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                                </el-button>
                                            </div>
                                        </div>
                                        <el-table size="mini" ref="mxTableRef" v-show="tableType == 0" :data="sendDataInfo.suSettleInvoiceVos" :row-class-name="tableRowClassName" border style="width: 100%"
                                                  :height="mxHeight">
                                            <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                                                             v-for="(formOneValue, formOneKey) in mxForm1" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                                <template slot-scope="scope">
                                                    <el-input @input="calculateTotal" v-if="formOneValue.entityField == 'settleMoney' && dataActionBox.actionType != 2"
                                                              :min="scope.row.oldBalance > 0 ? 0 : scope.row.oldBalance" :max="scope.row.oldBalance > 0 ? scope.row.oldBalance : 0" type="number"
                                                              v-model.trim="sendDataInfo.suSettleInvoiceVos[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(scope.row[formOneValue.riftField])">{{
                              scope.row[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else>{{ sendDataInfo.suSettleInvoiceVos[scope.$index][formOneValue.entityField]
                          }}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <el-table size="mini" v-show="tableType == 1" :data="sendDataInfo.suSettleInvoiceDetailVos" :row-class-name="tableRowClassName" border style="width: 100%" :height="mxHeight">
                                            <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDataIndex1" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                                                             v-for="(formOneValue, formOneKey) in mxForm2" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                                <template slot-scope="scope">
                                                    <el-input @input="calculateTotal" v-if="formOneValue.entityField == 'settleCount' && dataActionBox.actionType != 2&&!scope.row.sdmId"
                                                              :min="scope.row.oldBalancenum > 0 ? 0 : scope.row.oldBalancenum" :max="scope.row.oldBalancenum > 0 ? scope.row.oldBalancenum : 0" type="number"
                                                              v-model.trim="sendDataInfo.suSettleInvoiceDetailVos[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                    <input class="newInput" @input="toMoneys(scope.$index)" :ref="formOneValue.entityField" @keyup.enter="tableNextFocus2(formOneValue.focusField, scope.$index)"
                                                           v-else-if="formOneValue.entityField == 'settleMoney' && dataActionBox.actionType != 2&&!scope.row.sdmId" type="number"
                                                           :min="scope.row.oldBalance > 0 ? 0 : scope.row.oldBalance" :max="scope.row.oldBalance > 0 ? scope.row.oldBalance : 0"
                                                           v-model.trim="sendDataInfo.suSettleInvoiceDetailVos[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength" />
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(scope.row[formOneValue.riftField])">{{
                              scope.row[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else>{{ sendDataInfo.suSettleInvoiceDetailVos[scope.$index][formOneValue.entityField]
                          }}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" :top="'10px'">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible1" :visible.sync="DialogVisible1" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" top="10px">
            <SearchSchemeMultiple v-if="this.tableType == 1" ref="searchSchemeMultiple" @selection="selectClick" :id="searchId" :parentSearchData="parentSearchData1" :parentData="parentData" @TranData="changeInputModel"
                                  @getWidth="getSeWidth" @sendTitle="getSearchName" />
            <span slot="footer" v-if="this.tableType == 1" class="dialog-footer">
                <span>合计金额：</span>
                <span style="color: red;margin-right: 10px;">￥{{ money }}</span>
                <el-button @click="DialogVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="getSelect">确认选择</el-button>
            </span>
            <ExtractionPurPaymentApply v-else :extractParamsData="extractParamsData" :isMoney="true" :isMoneyType="'totalMoney'" :id="553755277398017" ref="ExtractionPurPaymentApply" :parentData="parentData"
                                       :invoiceExtractData="parentSearchData1" @invoiceExtractMethods="getSelect" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :modal-append-to-body='true' :append-to-body="true" width="90%" top="10vh">
            <ExtractSettleapply ref="ExtractSettleapply" :isSell="true" :detailTableColumn="mxForm2" @TranData="getDataByChen" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import SearchSchemeMultiple from "../byComponents/SearchSchemeMultiple.vue";
import ExtractSettleapply from "../byComponents/ExtractSettleapply.vue";
import ExtractionPurPaymentApply from "../byComponents/ExtractionPurPaymentApply.vue";
import purchaseGoodsTemplate from "@/components/purchaseGoodsTemplate.vue";
export default {
    name: "salesSettleApplyAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        SearchSchemeMultiple,
        ExtractSettleapply,
        ExtractionPurPaymentApply,
        purchaseGoodsTemplate
    },
    data() {
        //这里存放数据
        return {
            extractParamsData: {},
            selectDataTable: false,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            detaislDataInfo: {},
            selectedDataIndex: 0,
            selectedDataIndex1: 0,
            tableType: 0,
            sendDataInfo: {
                prereceSum: "",
                preMoney: 0,
                suSettleInvoiceVos: [], //按单据
                suSettleInvoiceDetailVos: [], //按明细
                psomBusdept: 0,
                cmId: "",
                cmName: "",
                dsapmDate: 0,
                isWms: 0,
                opmId: 0,
                opmName: "",
                dsapmRemark: "",
                desmReserves1: "",
                desmReserves2: "",
                desmReserves3: "",
                desmReserves4: "",
                desmReserves5: "",
                desmReserves6: "",
                salesId: "",
                salesName: "",
                totalCount: 0,
                totalMoney: 0,
                totalNumber: 0,
                psaiId: "",
                psomId: "",
                depId: "",
                depName: "",
                coId: "",
                coName: "",
                cbiAddress: "",
                cbiNumber: "",
                cbiName: "",
                settleMode: "",
                settleMethod: '',
                payMethod: "",
                prereceSum: '',
                payMoney: 0,
                acceptno: ''
            },
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            goodsList: [],
            storageRoomList: [],
            salesmanList: [],
            detailsBox: {
                status: false,
                type: 0,
                title: "新增" || "修改",
            },
            editDateilsIndex: "",
            isBuyer: 0,
            exId: "",
            seId: "",
            dialogTitle: "",
            seWidth: "",
            exTitle: "",
            seTitle: "",
            exWidth: "",
            DialogVisible: false,
            DialogVisible1: false,
            DialogExtract: false,
            newFormDataList: [],
            seType: "",
            smId: "",
            parentSearchData: {
                unitId: "",
                opmSalesperson: 1,
                opmBuyer: "",
            },
            parentSearchData1: {
                cmId: "",
                coId: "",
                opmId: "",
                salesId: "",
                depId: "",
            },
            searchId: "",
            mxHeight: 0,
            tabForm: [], // tab循环的主表单
            mxForm1: [],
            mxForm2: [],
            footForm: [],
            sField: '',
            form: [],
            parentData: {
                list: [],
                type: "",
            },
            money: 0,
            //-------------
            invoiceShow: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.cmName": {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.sendDataInfo.cmId = ''
                    this.sendDataInfo.salesName = "";
                    this.sendDataInfo.salesId = "";
                    this.sendDataInfo.secondcmName = "";
                    this.sendDataInfo.secondcmId = "";
                    this.parentSearchData1.salesId = "";
                    this.parentSearchData1.secondcmId = "";
                }
            },
            deep: true,
        },
        "sendDataInfo.preMoney": {
            handler: function (newValue, oldValue) {
                let a = newValue
                if (a == '') {
                    this.sendDataInfo.preMoney = 0
                } else if (a.length > 1 && a.substring(0, 1) == '0') {
                    this.sendDataInfo.preMoney = a.substring(1, a.length)
                }
            },
            deep: true,
        },
        "sendDataInfo.preMoney": {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.payMoney = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.totalMoney, this.sendDataInfo.preMoney))
            },
            deep: true,
        },
        "sendDataInfo.totalMoney": {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.payMoney = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.totalMoney, this.sendDataInfo.preMoney))
            },
            deep: true,
        },


    },
    //方法集合
    methods: {
        clearClick(setField) {
            if (!setField) {
                return
            }
            var arr = setField.split(',')
            arr.forEach(item => {
                this.$set(this.sendDataInfo, item, "")
            })
        },
        selectClick(val) {
            this.money = 0
            val.forEach(item => {
                var arr = this.sendDataInfo.suSettleInvoiceDetailVos.filter(val => val.dasdId == item.dasdId)
                if (arr.length == 0) {
                    this.money = this.$common.getDecimalInfo(3, NP.plus(item.psmoney, this.money))
                }
            })
            this.sendDataInfo.suSettleInvoiceDetailVos.forEach(item => {
                this.money = this.$common.getDecimalInfo(3, NP.plus(item.psmoney, this.money))
            })
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        //触发提取
        openExtSearch() {
            this.DialogExtract = true;
        },
        //提取返回
        async getDataByChen(val) {
            if (val != "" || val != undefined) {
                console.log('getDataByChen', val);
                this.tableType = val.settleMode
                if (this.tableType == 1) {
                    for (let key in val) {
                        if (key == "suSettleInvoiceDetailVos") {
                            this.sendDataInfo.suSettleInvoiceDetailVos = val.suSettleInvoiceDetailVos;
                        } else {
                            this.sendDataInfo[key] = val[key];
                            this.sendDataInfo.totalMoney = 0
                            // this.sendDataInfo.totalNumber = 0
                            this.sendDataInfo.totalCount = 0
                        }
                    }
                    // this.sendDataInfo.suSettleInvoiceDetailVos.forEach(item => {
                    // 	this.sendDataInfo.totalMoney += item.settleMoney
                    // 	// this.sendDataInfo.totalNumber += item.oldNum
                    // })
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, val.totalMoney)
                    this.sendDataInfo.totalCount = this.sendDataInfo.suSettleInvoiceDetailVos.length
                    this.DialogExtract = false;
                    this.getMoney()
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = 0
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.suSettleInvoiceDetailVos[this.selectedDetailsIndex]);
                        this.nextFocus(0)
                    })
                } else {
                    for (let key in val) {
                        if (key == "suSettleInvoiceVos") {
                            this.sendDataInfo.suSettleInvoiceVos = val.suSettleInvoiceVos;
                        } else {
                            this.sendDataInfo[key] = val[key];
                            this.sendDataInfo.totalMoney = 0
                            // this.sendDataInfo.totalNumber = 0
                            this.sendDataInfo.totalCount = 0
                        }
                    }
                    // this.sendDataInfo.suSettleInvoiceVos.forEach(item => {
                    // 	this.sendDataInfo.totalMoney += item.settleMoney
                    // 	// this.sendDataInfo.totalNumber += item.oldNum
                    // })
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, val.totalMoney)
                    this.sendDataInfo.totalCount = this.sendDataInfo.suSettleInvoiceVos.length
                    this.DialogExtract = false;
                    this.getMoney()
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = 0
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.suSettleInvoiceVos[this.selectedDetailsIndex]);
                        this.nextFocus(0)
                    })
                }
            }
            // this.parentSearchData.stId = this.sendDataInfo.stId
            // this.parentSearchData.cmId = this.sendDataInfo.cmId
            // this.parentSearchData.coId = this.sendDataInfo.coId
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) {
                return
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '') {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            const arrList = [
                {
                    id: 'coId',
                    value: this.form[this.form.findIndex(item => item.entityField == 'coName')]?.isShow
                }, {
                    id: 'cmId',
                    value: this.form[this.form.findIndex(item => item.entityField == 'cmName')]?.isShow
                }, {
                    id: 'opmId',
                    value: this.form[this.form.findIndex(item => item.entityField == 'opmName')]?.isShow
                }, {
                    id: 'salesId',
                    value: this.form[this.form.findIndex(item => item.entityField == 'salesName')]?.isShow
                }].filter(item => item.value).map(item => 'this.sendDataInfo.' + item.id + " != ''")
            console.log(arrList.join('&&'));
            this.$nextTick(() => {
                if (eval(arrList.join('&&'))) {
                    this.getMoney()
                }
                this.nextFocus(this.seIndex)
            })
        },
        async getMoney() {
            let sendData = {
                opmId: this.sendDataInfo.opmId,
                unitId: this.sendDataInfo.cmId,
                salesId: this.sendDataInfo.salesId,
                coId: this.sendDataInfo.coId,
                ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId
            }
            var responseData = await this.$http.shipPlanAddLoading(sendData);
            if (responseData.status == 200) {
                let res = responseData.result
                this.sendDataInfo.prereceSum = res.prereceSum
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //金额监听
        preMoneyChange(newVal) {
            if (this.sendDataInfo.cmId == "") {
                this.$data.sendDataInfo.preMoney = 0
                return this.$message({
                    message: "请先选择客户!",
                    type: "warning",
                })
            }
            if (Number(newVal) > Number(this.sendDataInfo.prereceSum)) {
                this.$data.sendDataInfo.preMoney = 0
                return this.$message({
                    message: "预收金额不能大于预收余额!",
                    type: "warning",
                })
            }
            if (Number(newVal) > this.sendDataInfo.totalMoney) {
                this.$data.sendDataInfo.preMoney = 0
                return this.$message({
                    message: "预收金额不能大于总金额!",
                    type: "warning",
                })
            }
            this.sendDataInfo.payMoney = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.totalMoney, this.sendDataInfo.preMoney))
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        calculateTotal(e) {
            if (this.tableType == 0) {
                if (!this.sendDataInfo.suSettleInvoiceVos || typeof this.sendDataInfo.suSettleInvoiceVos != 'object' || this.sendDataInfo.suSettleInvoiceVos == null) this.$set(this.sendDataInfo, 'suSettleInvoiceVos', [])
                this.sendDataInfo.totalMoney = 0;
                this.sendDataInfo.suSettleInvoiceDetailVos = []
                this.sendDataInfo.totalCount = this.sendDataInfo.suSettleInvoiceVos.length;
                if (this.sendDataInfo.suSettleInvoiceVos.length > 0) {
                    this.sendDataInfo.suSettleInvoiceVos.forEach((item) => {
                        if (item.oldBalance > 0) {
                            if (item.settleMoney > item.oldBalance)
                                item.settleMoney = item.oldBalance;
                            else if (item.settleMoney < 0) item.settleMoney = 0;
                        } else if (item.oldBalance < 0) {
                            if (item.settleMoney < item.oldBalance)
                                item.settleMoney = item.oldBalance;
                            else if (item.settleMoney > 0) item.settleMoney = 0;
                        }
                        this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                            3,
                            NP.plus(this.sendDataInfo.totalMoney, Number(item.settleMoney))
                        );
                    });
                }
            } else if (this.tableType == 1) {
                if (!this.sendDataInfo.suSettleInvoiceDetailVos || typeof this.sendDataInfo.suSettleInvoiceDetailVos != 'object' || this.sendDataInfo.suSettleInvoiceDetailVos == null) this.$set(this.sendDataInfo, 'suSettleInvoiceDetailVos', [])
                this.sendDataInfo.totalMoney = 0;
                this.sendDataInfo.suSettleInvoiceVos = []
                this.sendDataInfo.totalCount = this.sendDataInfo.suSettleInvoiceDetailVos.length;
                if (this.sendDataInfo.suSettleInvoiceDetailVos.length > 0) {
                    this.sendDataInfo.suSettleInvoiceDetailVos.forEach((item, index) => {
                        if (this.selectedDataIndex1 == index) {
                            if (item.settleCount == '' || !item.settleCount == undefined) {
                                item.settleCount = 0
                                item.settleMoney = 0
                            }
                        }
                        // 金额
                        // xtSalesSettlementList
                        item.settleMoney = this.$common.getDecimalInfo(
                            3,
                            NP.times(item.psprice, (item.settleCount || 0))
                        );
                        if (item.settleMoney == 0) {
                            item.settleMoney = ''
                        }
                        if (item.oldBalance > 0) {
                            if (item.settleMoney > item.oldBalance) {
                                item.settleMoney = item.oldBalance
                                item.settleCount = item.settleMoney / Number(item.psprice)
                            } else if (item.settleMoney < 0) {
                                item.settleMoney = 0
                                item.settleCount = 0
                            }
                        } else if (item.oldBalance < 0) {
                            if (item.settleMoney < item.oldBalance) {
                                item.settleMoney = item.oldBalance
                                item.settleCount = item.settleMoney / Number(item.psprice)
                            } else if (item.settleMoney > 0) {
                                item.settleMoney = 0
                                item.settleCount = 0
                            }
                        }
                        console.log(this.sendDataInfo.totalMoney, item.settleMoney);
                        // this.sendDataInfo.totalMoney = (+this.sendDataInfo.totalMoney + Number(item.settleMoney)).toFixed(2);
                        this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, (+this.sendDataInfo.totalMoney + Number(item.settleMoney)))

                    })
                }
            }
        },
        toMoneys(index) {
            this.$forceUpdate()
            var info = this.sendDataInfo.suSettleInvoiceDetailVos[index]

            if (info.oldBalance > 0) {
                if (info.settleMoney > info.oldBalance) {
                    this.sendDataInfo.suSettleInvoiceDetailVos[index].settleMoney = info.oldBalance
                    this.sendDataInfo.suSettleInvoiceDetailVos[index].settleCount = info.oldBalancenum
                } else if (info.settleMoney < 0) {
                    this.sendDataInfo.suSettleInvoiceDetailVos[index].settleMoney = 0
                    this.sendDataInfo.suSettleInvoiceDetailVos[index].settleCount = 0
                }
            } else if (info.oldBalance < 0) {
                if (info.settleMoney < info.oldBalance) {
                    this.sendDataInfo.suSettleInvoiceDetailVos[index].settleMoney = info.oldBalance
                    this.sendDataInfo.suSettleInvoiceDetailVos[index].settleCount = info.oldBalancenum
                } else if (info.settleMoney > 0) {
                    this.sendDataInfo.suSettleInvoiceDetailVos[index].settleMoney = 0
                    this.sendDataInfo.suSettleInvoiceDetailVos[index].settleCount = 0
                }
            }
            this.sendDataInfo.suSettleInvoiceDetailVos[index].settleCount = this.$common.getDecimalInfo(1, NP.divide(info.settleMoney, info.psprice))
            this.toMoney()
        },
        toMoney() {
            this.$forceUpdate()
            this.sendDataInfo.totalMoney = 0
            this.sendDataInfo.suSettleInvoiceDetailVos.forEach(item => {
                this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                    3,
                    NP.plus(this.sendDataInfo.totalMoney, Number(item.settleMoney))
                );
            })
        },
        getSelect(val) {
            this.calculateTotal()
            if (this.tableType == 0) {
                var mx = val.mainData
                this.sendDataInfo.suSettleInvoiceDetailVos = []
                this.sendDataInfo.suSettleInvoiceVos = mx;
                this.sendDataInfo.suSettleInvoiceVos.forEach((item) => {
                    this.$set(item, "settleMoney", item.oldBalance);
                });
                this.sendDataInfo.totalCount =
                    this.sendDataInfo.suSettleInvoiceVos.length;
            } else if (this.tableType == 1) {
                this.sendDataInfo.suSettleInvoiceVos = []
                var mx = this.$refs.searchSchemeMultiple.multipleSelection
                this.sendDataInfo.suSettleInvoiceDetailVos = mx;
                this.sendDataInfo.suSettleInvoiceDetailVos.forEach((item) => {
                    this.$set(item, "settleMoney", item.oldBalance);
                    this.$set(item, "settleCount", item.oldBalancenum);
                });
                this.sendDataInfo.totalCount =
                    this.sendDataInfo.suSettleInvoiceDetailVos.length;
            }
            this.DialogVisible1 = false;
            this.sendDataInfo.totalMoney = 0;
            this.calculateTotal()
        },
        extract(sendDataInfo, seId) {
            this.extractParamsData = { ...this.sendDataInfo }
            this.sField = ""		//调用同一返回方法，上次检索字段未清除
            this.money = 0
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.parentData.list = []
                    if (seId) {
                        this.tableType = 1
                        this.calculateTotal()
                    }
                    if (this.tableType == 0) {
                        this.searchId = "779666991583232"
                        if (this.sendDataInfo.suSettleInvoiceVos.length > 0) {
                            this.parentData.type = 'dasmId'
                            this.parentData.list = this.sendDataInfo.suSettleInvoiceVos
                        }
                    } else if (this.tableType == 1) {
                        this.searchId = seId ? seId : "789323919364096"
                        if (this.sendDataInfo.suSettleInvoiceDetailVos.length > 0) {
                            this.parentData.type = 'dasdId'
                            this.parentData.list = this.sendDataInfo.suSettleInvoiceDetailVos
                        }
                        this.sendDataInfo.suSettleInvoiceDetailVos.forEach(item => {
                            this.money = this.$common.getDecimalInfo(3, NP.plus(item.psmoney, this.money))
                        })
                    }
                    this.DialogVisible1 = true;
                }
            });
        },
        changeInputModel(val) {
            console.log('回带', this.sField, val);

            if (val != "" || val != undefined) {
                this.toMoney()
                this.DialogVisible = false;
                if (val.depId) {
                    this.parentSearchData1.depId = val.depId;
                }
                this.paramValue(val)
                console.log(this.seType);
                if (this.seType == "cmName") {
                    this.parentSearchData1.cmId = val.cmId;
                    this.parentSearchData.unitId = val.cmId;
                } else if (this.seType == "salesName") {
                    this.parentSearchData1.salesId = val.salesId;
                } else if (this.seType == "opmName") {
                    if (val.opmId) {
                        this.parentSearchData1.opmId = val.opmId;
                    }
                } else if (this.seType == "coName") {
                    this.parentSearchData1.coId = val.coId;
                }

            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        openSearch(sId, index, type, sField, fField, nosField) {
            if (type == 'salesName' || type == 'cbiAddress' || type == "secondcmName") {
                if (this.sendDataInfo.cmId == '') {
                    return this.$message({
                        message: '请先选择客户',
                        type: 'warning'
                    });
                }
            }
            if (type == 'secondcmName' || type == "opmName") {
                this.parentSearchData.cmId = this.sendDataInfo.cmId
            }
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        tableRowClassName({
            row,
            rowIndex
        }) {
            row.index = rowIndex;
        },
        detailsAction(cate = 0) {
            if (cate == 0) {
                this.editDateilsIndex = "";
                return false;
            }

            var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo));
            if (dataInfo.psodPacknum <= 0) {
                this.$message({
                    message: "请填写采购数量",
                    type: "error",
                });
                return false;
            }
            if (this.editDateilsIndex !== "") {
                this.sendDataInfo.pisOrderDetail.splice(this.editDateilsIndex, 1);
            }
            this.sendDataInfo.pisOrderDetail.push(dataInfo);
            this.editDateilsIndex = "";
            this.detailsBox.status = false;
        },
        initActionBox(sendDataInfo) {
            this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel");
                    this.init();
                    this.$refs.sendDataInfo.resetFields();
                })
                .catch(() => { });
        },
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "pisOrderAuxinf") {
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = "";
                    }
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            this.sendDataInfo.dsapmDate = this.$moment().valueOf();
            this.sendDataInfo.suSettleInvoiceDetailVos = [];
            this.sendDataInfo.suSettleInvoiceVos = [];
            this.sendDataInfo.isWms = 0;
            this.sendDataInfo.preMoney = 0;
            this.sendDataInfo.prereceSum = 0;
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
        },

        // 选择采购员
        selectUserOne(data) {
            data.forEach((item) => {
                if (item.opmId == this.sendDataInfo.opmId) {
                    this.sendDataInfo.psomBusdept = item.depId;
                }
            });
        },
        async isShowData(name, value) {
            switch (name) {
                case "supplier":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.smId = dataInfo.smId;
                        this.sendDataInfo.smName = dataInfo.smName;
                    }
                    this.sendDataInfo.salesId = "";
                    this.getUnitSalesmanList();
                    break;
                case "cargoOwner":
                    var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.pisOrderAuxinf.coId = dataInfo.coId;
                        this.sendDataInfo.pisOrderAuxinf.coName = dataInfo.coName;
                    }
                    break;
            }
        },
        selectDataAction(data) {
            this.detaislDataInfo = {
                // "bgmId":data.bgmId,
                bgmId: data.bgmId,
                bgmName: data.bgmName,
                inRate: data.bgfIntaxrate,
                bgmManufacturer: data.bgmManufacturer,
                bgmSpecifications: data.bgmSpecifications,
                bgmPlaceorigin: data.bgmPlaceorigin,
                money: 0,
                psodPacknum: 0,
                price: 0,
                psodPsdvolume: 0,
                psodPslowerlimit: 0,
                psmoney: 0,
                psodPsnvolume: 0,
                psprice: 0,
                psodPsupperlimit: 0,
                pspmId: "",
                stId: data.stId,
                pspdId: "",
                psodReserves1: "",
                psodReserves2: "",
                psodReserves3: "",
                psodReserves4: "",
                psodReserves5: "",
                psodReserves6: "",
            };
            this.selectDataTable = false;
        },
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.filterMainField()
            this.init();
            if (this.actionData.form) {
                this.form = this.actionData.form
            }
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.parentSearchData.unitId = "";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key];
                }
                this.smId = dataInfo.smId;
                this.getUnitSalesmanList();
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key];
                }
                this.tableType = this.sendDataInfo.settleMode
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus()
                }, 100)
            });
        },
        sendDataAction(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sub(sendDataInfo);
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        async sub(sendDataInfo) {
            if (this.tableType == 0) {  //0按单据1按明细
                this.sendDataInfo.settleMode = 0;
                var data1 = [];
                this.sendDataInfo.suSettleInvoiceVos.forEach((item) => {
                    data1.push({
                        dasmId: item.dasmId,
                        oldBalance: item.oldBalance,
                        settleMoney: item.settleMoney,
                        businessId: item.businessId,
                        businessType: item.businessType,
                        isDetail: item.isDetail,
                    });
                });
                this.sendDataInfo.suSettleApplyDetails = data1;
            } else {
                this.sendDataInfo.settleMode = 1;
                var data2 = [];
                this.sendDataInfo.suSettleInvoiceDetailVos.forEach((item) => {
                    data2.push({
                        dasdId: item.dasdId,
                        dasmId: item.dasmId,
                        oldBalance: item.oldBalance,
                        settleMoney: item.settleMoney,
                        settleCount: item.settleCount,
                        oldBalancenum: item.oldBalancenum,
                        businessType: item.businessType || "",
                        businessId: item.businessId || "",
                    });
                });
                this.sendDataInfo.suSettleApplyDetails = data2;
            }
            if (
                this.sendDataInfo.suSettleApplyDetails.some(
                    (val) => val.settleMoney == 0 || val.settleMoney == ""
                )
            ) {
                this.$message({
                    type: "error",
                    message: "明细或单据付款金额不能为0或者空",
                });
                return;
            } else {
                var money = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.totalMoney, this.sendDataInfo.preMoney))
                if (this.sendDataInfo.payMoney != money) {
                    this.$message({
                        type: "error",
                        message: "实收金额不等于总金额-预收金额，请检查！",
                    });
                    return;
                }
                var responseData = await this.$http.addSalesSettlementApply(
                    this.sendDataInfo
                );
                if (responseData.status == 200) {
                    this.init();
                    this.$message({
                        message: "操作成功",
                        type: "success",
                    });
                    this.$emit("drawerCancel");
                    this.$refs.sendDataInfo.resetFields();
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }
        },
        deleteDetails() {
            if (this.tableType == 0) {
                if (this.sendDataInfo.suSettleInvoiceVos.length > 0) {
                    this.sendDataInfo.suSettleInvoiceVos.splice(
                        this.selectedDataIndex,
                        1
                    );
                    this.selectedDataIndex = 0;
                    this.sendDataInfo.totalMoney = 0
                    this.sendDataInfo.suSettleInvoiceVos.forEach(item => {
                        this.sendDataInfo.totalMoney = this.sendDataInfo.totalMoney + Number(item.settleMoney)
                    })
                    this.sendDataInfo.totalCount =
                        this.sendDataInfo.suSettleInvoiceVos.length;
                } else {
                    return this.$message({
                        message: "暂无可删除明细",
                        type: "warning",
                    });
                }
            } else if (this.tableType == 1) {
                if (this.sendDataInfo.suSettleInvoiceDetailVos.length > 0) {
                    this.sendDataInfo.suSettleInvoiceDetailVos.splice(
                        this.selectedDataIndex1,
                        1
                    );
                    this.selectedDataIndex1 = 0;
                    this.sendDataInfo.totalMoney = 0
                    this.sendDataInfo.suSettleInvoiceDetailVos.forEach(item => {
                        this.sendDataInfo.totalMoney = this.sendDataInfo.totalMoney + Number(item.settleMoney)
                    })
                    this.sendDataInfo.totalCount =
                        this.sendDataInfo.suSettleInvoiceDetailVos.length;
                } else {
                    return this.$message({
                        message: "暂无可删除明细",
                        type: "warning",
                    });
                }
            }
        },
        // 获取业务员
        async getUnitSalesmanList() {
            this.salesmanList = [];
            let responseData = await this.$http.getUnitSalesmanList({
                ids: [this.sendDataInfo.smId],
            });
            if (responseData.status == 200) {
                this.salesmanList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取供货员
        async getSpecialUser() {
            let responseData = await this.$http.getSpecialUser({
                opmBuyer: 1
            });
            if (responseData.status == 200) {
                this.userOneList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [20, 21],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取所有可用库房列表
        async getAllStorageRoom() {
            let responseData = await this.$http.getAllStorageRoom();
            if (responseData.status == 200) {
                this.storageRoomList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 判断是不是采购员
        checkIsBuyer() {
            let info = JSON.parse(sessionStorage.getItem('userInfo'))
            if (info.opmSalesperson == 1) {
                this.isBuyer = 1
                this.parentSearchData1.depId = info.depId
                this.parentSearchData1.opmId = info.opmId
                this.sendDataInfo.depName = info.depName
                this.sendDataInfo.depId = info.depId
                this.sendDataInfo.opmName = info.opmName
                this.sendDataInfo.opmId = info.opmId
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            let formArr = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    formArr.push(JSON.parse(JSON.stringify(item.jurconfigform)))
                    // this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            this.mxForm1 = formArr[0]
            this.mxForm2 = formArr[1]
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
                        .jurconfigform[index])
                }
            })
            var arr = [{ entityField: "suSettleInvoiceDetailVos" }, { entityField: "suSettleInvoiceVos" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.$set(this.sendDataInfo, "dsapmDate", this.$moment().valueOf())
            this.$set(this.sendDataInfo, "isWms", 0)
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.invoiceShow = window.global_config.extendShow ? true : false
            this.openBox();
            // this.checkIsBuyer()
        });
        // this.getSpecialUser();
        // this.getUnitSalesmanList();
        // this.getPartDictionariesData();
        // this.getAllStorageRoom();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        document.onkeydown = function () {
            if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                window.event.returnValue = false;
            }
        }
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

.flex {
    display: flex;
    align-items: center;
}
</style>